// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top {
    position: fixed;
    bottom: 80px;
    right: 20px;
    background-color: #333;
    color: #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease, transform 0.3s ease;
    z-index: 1000;
  }
  
  .scroll-to-top:hover {
    background-color: #555;
    transform: scale(1.1);
  }
  
  .scroll-to-top svg {
    font-size: 1.5rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/components/ScrollToTopButton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,wCAAwC;IACxC,2DAA2D;IAC3D,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".scroll-to-top {\r\n    position: fixed;\r\n    bottom: 80px;\r\n    right: 20px;\r\n    background-color: #333;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 50px;\r\n    height: 50px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .scroll-to-top:hover {\r\n    background-color: #555;\r\n    transform: scale(1.1);\r\n  }\r\n  \r\n  .scroll-to-top svg {\r\n    font-size: 1.5rem;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
